import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import jobImage from '../../assets/images/khojgraphics/Moving_graphic_1.gif';



ReviewJob10.propTypes = {};

function ReviewJob10({ className }) {
	return (
		<>
			<section className="review-job-section-four">
				<Tabs className="tf-tab">
					<div className="container">
						<div className="row aln-center-mb tf-title">

							<div className="col-lg-5">
								<h1 className="f-600 mb-4 mobile-title">And From This Foundation, KHOJ was born.</h1>
								<div className="wd-review-job thumb-style3 text-center Foundation-review-job">

									<img
										src={jobImage}
										alt="images"
										width={'90%'}
									/>
								</div>
							</div>

							<div className="col-lg-7 content-tab wow fadeInRight ">
								<h1 className="f-600 mb-2 web-title">And From This Foundation, <span className="khoj-text-color">KHOJ</span> came into being. </h1>
								{/* <h5 className="f-600 mb-3"></h5> */}
								<p>Khoj is the embodiment of years of research, collaboration, and an unrelenting pursuit to bridge the gap between dreams and destinations. It addresses the disconnect between what the industry needs and how talent is prepared, ensuring that no skill goes unnoticed, no opportunity goes unexplored, and no individual feels left behind.</p>
								<p>What sets this journey apart is its human core. Khoj  isn’t a product—it’s a promise. It’s a commitment to simplifying the most complex career transitions while amplifying opportunities for growth. Khoj's story is one of evolution, driven by a bold vision to uplift individuals, enrich organizations, and shape the future of work. It is a testament to People Labs’ unwavering dedication not just to bridging gaps but to building bridges strong enough to carry generations forward. </p>
								<p>This is the journey of Khoj: an idea that dared to dream beyond limitations and a solution that continues to make those dreams come true.</p>
								{/* <p>Khoj isn’t just a portal—it’s a solution born from years of experience, designed to solve a critical problem faced by many at the start of their professional journey. It’s a bridge between untapped potential and meaningful opportunity, specifically crafted for individuals in the first 0-9 years of their career. With this platform, you’re equipped to make informed, confident decisions, nurturing connections and building a network that evolves with you.</p>
								<p>The goal is to bridge the gap between what you’ve been taught and what the world needs from you—guiding you toward roles that make a difference, and connecting you with opportunities that align with your true self. At Khoj, we’re committed to ensuring that, from your very first step, you’re supported, empowered, and ready to forge a career that speaks to your heart.</p> */}
							</div>

						</div>
					</div>
				</Tabs>
			</section>
		</>
	);
}

export default ReviewJob10;
